//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.1.0 (NJsonSchema v11.5.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { FileParameter, FileResponse } from '../../models/file-models';
import { columnMap } from '../../../shared/table/models/column-map.decorator';
import { keyMap } from '../../../shared/table/models/key-map.decorator';
import {
    ApiActivity,
    IApiActivity,
    ApiNamedListItem,
    ApiIdNameItem,
    IApiIdNameItem,
    ApiMemberInfo,
    ApiNote,
    IApiNote,
    ApiFileInfo,
    IApiFileInfo,
    ApiListItemPosition,
    ApiRange,
    ApiText,
    IApiMemberInfo,
    ApiCreateMemberRequest,
    ApiDateRange,
    ApiNoteListItem,
    BackgroundProcessEnum,
    BackgroundProcessStatusEnum,
    BackgroundProcessStepStatus,
    NoteTypeEnum,
    SocialNetworkEnum,
    FileUploadErrorEnum,
    ApiExternalAccountInfo,
    Module,
    Permission,
    ServicesEnum,
    ApiCreatorInfo,
    FileValidationModel,
    TimerTaskType,
    Gender
} from './open-api-clients';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class CountriesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getCountryList(): Observable<ApiNamedListItem[]> {
        let url_ = this.baseUrl + "/api/shared/country/country-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNamedListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNamedListItem[]>;
        }));
    }

    protected processGetCountryList(response: HttpResponseBase): Observable<ApiNamedListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getRegionCountryList(): Observable<ApiRegionCountry[]> {
        let url_ = this.baseUrl + "/api/shared/country/region-country-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionCountryList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionCountryList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiRegionCountry[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiRegionCountry[]>;
        }));
    }

    protected processGetRegionCountryList(response: HttpResponseBase): Observable<ApiRegionCountry[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiRegionCountry.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getCountryByIp(): Observable<ApiNamedListItem> {
        let url_ = this.baseUrl + "/api/shared/country/country";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryByIp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryByIp(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNamedListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNamedListItem>;
        }));
    }

    protected processGetCountryByIp(response: HttpResponseBase): Observable<ApiNamedListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiNamedListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CountryIpRangesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getCountryIpList(ids: string[] | null | undefined): Observable<ApiCountryIpRange[]> {
        let url_ = this.baseUrl + "/api/shared/country-ip-ranges?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryIpList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryIpList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiCountryIpRange[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiCountryIpRange[]>;
        }));
    }

    protected processGetCountryIpList(response: HttpResponseBase): Observable<ApiCountryIpRange[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiCountryIpRange.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GridClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    findGridOrganizations(query: string | null | undefined): Observable<ApiGridOrganization[]> {
        let url_ = this.baseUrl + "/api/shared/grid/grid-organizations?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindGridOrganizations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindGridOrganizations(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiGridOrganization[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiGridOrganization[]>;
        }));
    }

    protected processFindGridOrganizations(response: HttpResponseBase): Observable<ApiGridOrganization[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiGridOrganization.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MemberTitlesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getMemberTitles(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/shared/member-titles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<string[]>;
        }));
    }

    protected processGetMemberTitles(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TextClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    cleanAndCapitalize(content: ApiText): Observable<string> {
        let url_ = this.baseUrl + "/api/shared/text/clean-and-capitalize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(content);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCleanAndCapitalize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCleanAndCapitalize(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<string>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<string>;
        }));
    }

    protected processCleanAndCapitalize(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ApiRegionCountry implements IApiRegionCountry {
    id?: string | null;
    name?: string | null;
    region?: RegionEnum | null;

    constructor(data?: IApiRegionCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.region = _data["region"] !== undefined ? _data["region"] : null as any;
        }
    }

    static fromJS(data: any): ApiRegionCountry {
        data = typeof data === 'object' ? data : {};
        let result = new ApiRegionCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["region"] = this.region !== undefined ? this.region : null as any;
        return data;
    }
}

export interface IApiRegionCountry {
    id?: string | null;
    name?: string | null;
    region?: RegionEnum | null;
}

export enum RegionEnum {
    Africa = 1,
    America = 2,
    Asia = 4,
    Europe = 8,
    Oceania = 16,
}

export class ApiCountryIpRange implements IApiCountryIpRange {
    countryId?: string | null;
    ipRanges?: ApiIpRange[] | null;

    constructor(data?: IApiCountryIpRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            if (Array.isArray(_data["ipRanges"])) {
                this.ipRanges = [] as any;
                for (let item of _data["ipRanges"])
                    this.ipRanges!.push(ApiIpRange.fromJS(item));
            }
            else {
                this.ipRanges = null as any;
            }
        }
    }

    static fromJS(data: any): ApiCountryIpRange {
        data = typeof data === 'object' ? data : {};
        let result = new ApiCountryIpRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        if (Array.isArray(this.ipRanges)) {
            data["ipRanges"] = [];
            for (let item of this.ipRanges)
                data["ipRanges"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IApiCountryIpRange {
    countryId?: string | null;
    ipRanges?: ApiIpRange[] | null;
}

export class ApiIpRange implements IApiIpRange {
    start?: number;
    end?: number;

    constructor(data?: IApiIpRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] !== undefined ? _data["start"] : null as any;
            this.end = _data["end"] !== undefined ? _data["end"] : null as any;
        }
    }

    static fromJS(data: any): ApiIpRange {
        data = typeof data === 'object' ? data : {};
        let result = new ApiIpRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start !== undefined ? this.start : null as any;
        data["end"] = this.end !== undefined ? this.end : null as any;
        return data;
    }
}

export interface IApiIpRange {
    start?: number;
    end?: number;
}

export class ApiGridOrganization implements IApiGridOrganization {
    id?: string | null;
    name?: string | null;
    countryCode?: string | null;
    state?: string | null;
    city?: string | null;
    zip?: string | null;
    websites?: string[] | null;

    constructor(data?: IApiGridOrganization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            if (Array.isArray(_data["websites"])) {
                this.websites = [] as any;
                for (let item of _data["websites"])
                    this.websites!.push(item);
            }
            else {
                this.websites = null as any;
            }
        }
    }

    static fromJS(data: any): ApiGridOrganization {
        data = typeof data === 'object' ? data : {};
        let result = new ApiGridOrganization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        if (Array.isArray(this.websites)) {
            data["websites"] = [];
            for (let item of this.websites)
                data["websites"].push(item);
        }
        return data;
    }
}

export interface IApiGridOrganization {
    id?: string | null;
    name?: string | null;
    countryCode?: string | null;
    state?: string | null;
    city?: string | null;
    zip?: string | null;
    websites?: string[] | null;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(() => result);
    else
        return _observableThrow(() => new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<any> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            if (typeof window === 'undefined') {
                observer.next(blob);
                observer.complete();
            } else {
                let reader = new FileReader();
                reader.onload = event => {
                    observer.next((event.target as any).result);
                    observer.complete();
                };
                reader.readAsText(blob);
            }
        }
    });
}

/* tslint:disable */
/* eslint-disable */